/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/**
 * This file was auto-generated by `yarn generate-openapi-contracts`.
 * Do not make direct changes to the file.
 */

import { fetchAsJson, applyParameters } from '@modules/query/helpers'
import type { Exact } from '@modules/ts-essentials'

import type { operations, components } from './types'

// POST /api/v1/admin/serverless/projects/_convert-to-paid
// ts-unused-exports:disable-next-line
export const convertOrganizationProjectsToPaid = async (args: {
  queryParameters: operations['convertOrganizationProjectsToPaid']['parameters']['query']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/admin/serverless/projects/_convert-to-paid', args), {
    method: 'POST',
  })

// POST /api/v1/admin/serverless/projects/_suspend
// ts-unused-exports:disable-next-line
export const suspendOrganizationProjects = async <
  T = operations['suspendOrganizationProjects']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['suspendOrganizationProjects']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  queryParameters: operations['suspendOrganizationProjects']['parameters']['query']
  body: Exact<
    T,
    operations['suspendOrganizationProjects']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['suspendOrganizationProjects']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/admin/serverless/projects/_suspend', args), {
    method: 'POST',
    body: JSON.stringify(args.body),
  })

// GET /api/v1/admin/serverless/projects/elasticsearch
// ts-unused-exports:disable-next-line
export const listElasticsearchProjects = async (args?: {
  queryParameters?: operations['adminListElasticsearchProjects']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['ElasticsearchProjectList']>(
    applyParameters('/api/v1/admin/serverless/projects/elasticsearch', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/elasticsearch/{id}
// ts-unused-exports:disable-next-line
export const getElasticsearchProject = async (args: {
  pathParameters: operations['adminGetElasticsearchProject']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ElasticsearchProject']>(
    applyParameters('/api/v1/admin/serverless/projects/elasticsearch/{id}', args),
    {
      method: 'GET',
    },
  )

// PATCH /api/v1/admin/serverless/projects/elasticsearch/{id}
// ts-unused-exports:disable-next-line
export const patchElasticsearchProject = async <
  T = operations['adminPatchElasticsearchProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminPatchElasticsearchProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['adminPatchElasticsearchProject']['parameters']['path']
  body: Exact<
    T,
    operations['adminPatchElasticsearchProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminPatchElasticsearchProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['ElasticsearchProject']>(
    applyParameters('/api/v1/admin/serverless/projects/elasticsearch/{id}', args),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/admin/serverless/projects/elasticsearch/{id}
// ts-unused-exports:disable-next-line
export const deleteElasticsearchProject = async (args: {
  pathParameters: operations['adminDeleteElasticsearchProject']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/admin/serverless/projects/elasticsearch/{id}', args), {
    method: 'DELETE',
  })

// GET /api/v1/admin/serverless/projects/elasticsearch/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxyElasticsearchProjectGetRequest = async <
  T = operations['adminProxyElasticsearchProjectGetRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxyElasticsearchProjectGetRequest']['requestBody'],
        undefined
      >['content']['*:*'],
>(args: {
  pathParameters: operations['adminProxyElasticsearchProjectGetRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxyElasticsearchProjectGetRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxyElasticsearchProjectGetRequest']['requestBody'],
          undefined
        >['content']['*:*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/elasticsearch/{id}/_proxy/{path}', args),
    {
      method: 'GET',
      body: JSON.stringify(args.body),
    },
  )

// PUT /api/v1/admin/serverless/projects/elasticsearch/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxyElasticsearchProjectPutRequest = async <
  T = operations['adminProxyElasticsearchProjectPutRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxyElasticsearchProjectPutRequest']['requestBody'],
        undefined
      >['content']['*/*'],
>(args: {
  pathParameters: operations['adminProxyElasticsearchProjectPutRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxyElasticsearchProjectPutRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxyElasticsearchProjectPutRequest']['requestBody'],
          undefined
        >['content']['*/*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/elasticsearch/{id}/_proxy/{path}', args),
    {
      method: 'PUT',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/admin/serverless/projects/elasticsearch/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxyElasticsearchProjectPostRequest = async <
  T = operations['adminProxyElasticsearchProjectPostRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxyElasticsearchProjectPostRequest']['requestBody'],
        undefined
      >['content']['*/*'],
>(args: {
  pathParameters: operations['adminProxyElasticsearchProjectPostRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxyElasticsearchProjectPostRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxyElasticsearchProjectPostRequest']['requestBody'],
          undefined
        >['content']['*/*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/elasticsearch/{id}/_proxy/{path}', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/admin/serverless/projects/elasticsearch/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxyElasticsearchProjectDeleteRequest = async <
  T = operations['adminProxyElasticsearchProjectDeleteRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxyElasticsearchProjectDeleteRequest']['requestBody'],
        undefined
      >['content']['*/*'],
>(args: {
  pathParameters: operations['adminProxyElasticsearchProjectDeleteRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxyElasticsearchProjectDeleteRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxyElasticsearchProjectDeleteRequest']['requestBody'],
          undefined
        >['content']['*/*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/elasticsearch/{id}/_proxy/{path}', args),
    {
      method: 'DELETE',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/admin/serverless/projects/elasticsearch/{id}/_reprocess
// ts-unused-exports:disable-next-line
export const reprocessElasticsearchProject = async (args: {
  pathParameters: operations['adminReprocessElasticsearchProject']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/admin/serverless/projects/elasticsearch/{id}/_reprocess', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/admin/serverless/projects/elasticsearch/{id}/_restore
// ts-unused-exports:disable-next-line
export const restoreElasticsearchProject = async (args: {
  pathParameters: operations['adminRestoreElasticsearchProject']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/admin/serverless/projects/elasticsearch/{id}/_restore', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/admin/serverless/projects/elasticsearch/{id}/_rotate-fleet-token
// ts-unused-exports:disable-next-line
export const rotateElasticsearchProjectFleetToken = async (args: {
  pathParameters: operations['adminRotateElasticsearchProjectFleetToken']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters(
      '/api/v1/admin/serverless/projects/elasticsearch/{id}/_rotate-fleet-token',
      args,
    ),
    {
      method: 'POST',
    },
  )

// POST /api/v1/admin/serverless/projects/elasticsearch/{id}/_rotate-kibana-token
// ts-unused-exports:disable-next-line
export const rotateElasticsearchProjectKibanaToken = async (args: {
  pathParameters: operations['adminRotateElasticsearchProjectKibanaToken']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters(
      '/api/v1/admin/serverless/projects/elasticsearch/{id}/_rotate-kibana-token',
      args,
    ),
    {
      method: 'POST',
    },
  )

// GET /api/v1/admin/serverless/projects/elasticsearch/{id}/link-candidates
// ts-unused-exports:disable-next-line
export const getElasticsearchProjectLinkCandidates = async (args: {
  pathParameters: operations['adminGetElasticsearchProjectLinkCandidates']['parameters']['path']
  queryParameters?: operations['adminGetElasticsearchProjectLinkCandidates']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['LinkedCandidatesList']>(
    applyParameters('/api/v1/admin/serverless/projects/elasticsearch/{id}/link-candidates', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/elasticsearch/{id}/roles
// ts-unused-exports:disable-next-line
export const getElasticsearchProjectRoles = async (args: {
  pathParameters: operations['adminGetElasticsearchProjectRoles']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectRolesByProjectID']>(
    applyParameters('/api/v1/admin/serverless/projects/elasticsearch/{id}/roles', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/elasticsearch/{id}/status
// ts-unused-exports:disable-next-line
export const getElasticsearchProjectStatus = async (args: {
  pathParameters: operations['adminGetElasticsearchProjectStatus']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectStatus']>(
    applyParameters('/api/v1/admin/serverless/projects/elasticsearch/{id}/status', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/observability
// ts-unused-exports:disable-next-line
export const listObservabilityProjects = async (args?: {
  queryParameters?: operations['adminListObservabilityProjects']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['ObservabilityProjectList']>(
    applyParameters('/api/v1/admin/serverless/projects/observability', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/observability/{id}
// ts-unused-exports:disable-next-line
export const getObservabilityProject = async (args: {
  pathParameters: operations['adminGetObservabilityProject']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ObservabilityProject']>(
    applyParameters('/api/v1/admin/serverless/projects/observability/{id}', args),
    {
      method: 'GET',
    },
  )

// PATCH /api/v1/admin/serverless/projects/observability/{id}
// ts-unused-exports:disable-next-line
export const patchObservabilityProject = async <
  T = operations['adminPatchObservabilityProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminPatchObservabilityProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['adminPatchObservabilityProject']['parameters']['path']
  body: Exact<
    T,
    operations['adminPatchObservabilityProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminPatchObservabilityProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['ObservabilityProject']>(
    applyParameters('/api/v1/admin/serverless/projects/observability/{id}', args),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/admin/serverless/projects/observability/{id}
// ts-unused-exports:disable-next-line
export const deleteObservabilityProject = async (args: {
  pathParameters: operations['adminDeleteObservabilityProject']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/admin/serverless/projects/observability/{id}', args), {
    method: 'DELETE',
  })

// GET /api/v1/admin/serverless/projects/observability/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxyObservabilityProjectGetRequest = async <
  T = operations['adminProxyObservabilityProjectGetRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxyObservabilityProjectGetRequest']['requestBody'],
        undefined
      >['content']['*:*'],
>(args: {
  pathParameters: operations['adminProxyObservabilityProjectGetRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxyObservabilityProjectGetRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxyObservabilityProjectGetRequest']['requestBody'],
          undefined
        >['content']['*:*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/observability/{id}/_proxy/{path}', args),
    {
      method: 'GET',
      body: JSON.stringify(args.body),
    },
  )

// PUT /api/v1/admin/serverless/projects/observability/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxyObservabilityProjectPutRequest = async <
  T = operations['adminProxyObservabilityProjectPutRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxyObservabilityProjectPutRequest']['requestBody'],
        undefined
      >['content']['*/*'],
>(args: {
  pathParameters: operations['adminProxyObservabilityProjectPutRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxyObservabilityProjectPutRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxyObservabilityProjectPutRequest']['requestBody'],
          undefined
        >['content']['*/*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/observability/{id}/_proxy/{path}', args),
    {
      method: 'PUT',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/admin/serverless/projects/observability/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxyObservabilityProjectPostRequest = async <
  T = operations['adminProxyObservabilityProjectPostRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxyObservabilityProjectPostRequest']['requestBody'],
        undefined
      >['content']['*/*'],
>(args: {
  pathParameters: operations['adminProxyObservabilityProjectPostRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxyObservabilityProjectPostRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxyObservabilityProjectPostRequest']['requestBody'],
          undefined
        >['content']['*/*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/observability/{id}/_proxy/{path}', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/admin/serverless/projects/observability/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxyObservabilityProjectDeleteRequest = async <
  T = operations['adminProxyObservabilityProjectDeleteRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxyObservabilityProjectDeleteRequest']['requestBody'],
        undefined
      >['content']['*/*'],
>(args: {
  pathParameters: operations['adminProxyObservabilityProjectDeleteRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxyObservabilityProjectDeleteRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxyObservabilityProjectDeleteRequest']['requestBody'],
          undefined
        >['content']['*/*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/observability/{id}/_proxy/{path}', args),
    {
      method: 'DELETE',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/admin/serverless/projects/observability/{id}/_reprocess
// ts-unused-exports:disable-next-line
export const reprocessObservabilityProject = async (args: {
  pathParameters: operations['adminReprocessObservabilityProject']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/admin/serverless/projects/observability/{id}/_reprocess', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/admin/serverless/projects/observability/{id}/_restore
// ts-unused-exports:disable-next-line
export const restoreObservabilityProject = async (args: {
  pathParameters: operations['adminRestoreObservabilityProject']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/admin/serverless/projects/observability/{id}/_restore', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/admin/serverless/projects/observability/{id}/_rotate-fleet-token
// ts-unused-exports:disable-next-line
export const rotateObservabilityProjectFleetToken = async (args: {
  pathParameters: operations['adminRotateObservabilityProjectFleetToken']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters(
      '/api/v1/admin/serverless/projects/observability/{id}/_rotate-fleet-token',
      args,
    ),
    {
      method: 'POST',
    },
  )

// POST /api/v1/admin/serverless/projects/observability/{id}/_rotate-kibana-token
// ts-unused-exports:disable-next-line
export const rotateObservabilityProjectKibanaToken = async (args: {
  pathParameters: operations['adminRotateObservabilityProjectKibanaToken']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters(
      '/api/v1/admin/serverless/projects/observability/{id}/_rotate-kibana-token',
      args,
    ),
    {
      method: 'POST',
    },
  )

// GET /api/v1/admin/serverless/projects/observability/{id}/link-candidates
// ts-unused-exports:disable-next-line
export const getObservabilityProjectLinkCandidates = async (args: {
  pathParameters: operations['adminGetObservabilityProjectLinkCandidates']['parameters']['path']
  queryParameters?: operations['adminGetObservabilityProjectLinkCandidates']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['LinkedCandidatesList']>(
    applyParameters('/api/v1/admin/serverless/projects/observability/{id}/link-candidates', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/observability/{id}/roles
// ts-unused-exports:disable-next-line
export const getObservabilityProjectRoles = async (args: {
  pathParameters: operations['adminGetObservabilityProjectRoles']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectRolesByProjectID']>(
    applyParameters('/api/v1/admin/serverless/projects/observability/{id}/roles', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/observability/{id}/status
// ts-unused-exports:disable-next-line
export const getObservabilityProjectStatus = async (args: {
  pathParameters: operations['adminGetObservabilityProjectStatus']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectStatus']>(
    applyParameters('/api/v1/admin/serverless/projects/observability/{id}/status', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/security
// ts-unused-exports:disable-next-line
export const listSecurityProjects = async (args?: {
  queryParameters?: operations['adminListSecurityProjects']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['SecurityProjectList']>(
    applyParameters('/api/v1/admin/serverless/projects/security', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/security/{id}
// ts-unused-exports:disable-next-line
export const getSecurityProject = async (args: {
  pathParameters: operations['adminGetSecurityProject']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['SecurityProject']>(
    applyParameters('/api/v1/admin/serverless/projects/security/{id}', args),
    {
      method: 'GET',
    },
  )

// PATCH /api/v1/admin/serverless/projects/security/{id}
// ts-unused-exports:disable-next-line
export const patchSecurityProject = async <
  T = operations['adminPatchSecurityProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminPatchSecurityProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['adminPatchSecurityProject']['parameters']['path']
  body: Exact<
    T,
    operations['adminPatchSecurityProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminPatchSecurityProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['SecurityProject']>(
    applyParameters('/api/v1/admin/serverless/projects/security/{id}', args),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/admin/serverless/projects/security/{id}
// ts-unused-exports:disable-next-line
export const deleteSecurityProject = async (args: {
  pathParameters: operations['adminDeleteSecurityProject']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/admin/serverless/projects/security/{id}', args), {
    method: 'DELETE',
  })

// GET /api/v1/admin/serverless/projects/security/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxySecurityProjectGetRequest = async <
  T = operations['adminProxySecurityProjectGetRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxySecurityProjectGetRequest']['requestBody'],
        undefined
      >['content']['*:*'],
>(args: {
  pathParameters: operations['adminProxySecurityProjectGetRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxySecurityProjectGetRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxySecurityProjectGetRequest']['requestBody'],
          undefined
        >['content']['*:*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/security/{id}/_proxy/{path}', args),
    {
      method: 'GET',
      body: JSON.stringify(args.body),
    },
  )

// PUT /api/v1/admin/serverless/projects/security/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxySecurityProjectPutRequest = async <
  T = operations['adminProxySecurityProjectPutRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxySecurityProjectPutRequest']['requestBody'],
        undefined
      >['content']['*/*'],
>(args: {
  pathParameters: operations['adminProxySecurityProjectPutRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxySecurityProjectPutRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxySecurityProjectPutRequest']['requestBody'],
          undefined
        >['content']['*/*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/security/{id}/_proxy/{path}', args),
    {
      method: 'PUT',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/admin/serverless/projects/security/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxySecurityProjectPostRequest = async <
  T = operations['adminProxySecurityProjectPostRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxySecurityProjectPostRequest']['requestBody'],
        undefined
      >['content']['*/*'],
>(args: {
  pathParameters: operations['adminProxySecurityProjectPostRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxySecurityProjectPostRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxySecurityProjectPostRequest']['requestBody'],
          undefined
        >['content']['*/*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/security/{id}/_proxy/{path}', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/admin/serverless/projects/security/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxySecurityProjectDeleteRequest = async <
  T = operations['adminProxySecurityProjectDeleteRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxySecurityProjectDeleteRequest']['requestBody'],
        undefined
      >['content']['*/*'],
>(args: {
  pathParameters: operations['adminProxySecurityProjectDeleteRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxySecurityProjectDeleteRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxySecurityProjectDeleteRequest']['requestBody'],
          undefined
        >['content']['*/*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/security/{id}/_proxy/{path}', args),
    {
      method: 'DELETE',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/admin/serverless/projects/security/{id}/_reprocess
// ts-unused-exports:disable-next-line
export const reprocessSecurityProject = async (args: {
  pathParameters: operations['adminReprocessSecurityProject']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/admin/serverless/projects/security/{id}/_reprocess', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/admin/serverless/projects/security/{id}/_restore
// ts-unused-exports:disable-next-line
export const restoreSecurityProject = async (args: {
  pathParameters: operations['adminRestoreSecurityProject']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/admin/serverless/projects/security/{id}/_restore', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/admin/serverless/projects/security/{id}/_rotate-fleet-token
// ts-unused-exports:disable-next-line
export const rotateSecurityProjectFleetToken = async (args: {
  pathParameters: operations['adminRotateSecurityProjectFleetToken']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/admin/serverless/projects/security/{id}/_rotate-fleet-token', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/admin/serverless/projects/security/{id}/_rotate-kibana-token
// ts-unused-exports:disable-next-line
export const rotateSecurityProjectKibanaToken = async (args: {
  pathParameters: operations['adminRotateSecurityProjectKibanaToken']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/admin/serverless/projects/security/{id}/_rotate-kibana-token', args),
    {
      method: 'POST',
    },
  )

// GET /api/v1/admin/serverless/projects/security/{id}/link-candidates
// ts-unused-exports:disable-next-line
export const getSecurityProjectLinkCandidates = async (args: {
  pathParameters: operations['adminGetSecurityProjectLinkCandidates']['parameters']['path']
  queryParameters?: operations['adminGetSecurityProjectLinkCandidates']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['LinkedCandidatesList']>(
    applyParameters('/api/v1/admin/serverless/projects/security/{id}/link-candidates', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/security/{id}/roles
// ts-unused-exports:disable-next-line
export const getSecurityProjectRoles = async (args: {
  pathParameters: operations['adminGetSecurityProjectRoles']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectRolesByProjectID']>(
    applyParameters('/api/v1/admin/serverless/projects/security/{id}/roles', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/security/{id}/status
// ts-unused-exports:disable-next-line
export const getSecurityProjectStatus = async (args: {
  pathParameters: operations['adminGetSecurityProjectStatus']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectStatus']>(
    applyParameters('/api/v1/admin/serverless/projects/security/{id}/status', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/workplaceai
// ts-unused-exports:disable-next-line
export const listWorkplaceAIProjects = async (args?: {
  queryParameters?: operations['adminListWorkplaceAIProjects']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['WorkplaceAIProjectList']>(
    applyParameters('/api/v1/admin/serverless/projects/workplaceai', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/workplaceai/{id}
// ts-unused-exports:disable-next-line
export const getWorkplaceAIProject = async (args: {
  pathParameters: operations['adminGetWorkplaceAIProject']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['WorkplaceAIProject']>(
    applyParameters('/api/v1/admin/serverless/projects/workplaceai/{id}', args),
    {
      method: 'GET',
    },
  )

// PATCH /api/v1/admin/serverless/projects/workplaceai/{id}
// ts-unused-exports:disable-next-line
export const patchWorkplaceAIProject = async <
  T = operations['adminPatchWorkplaceAIProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminPatchWorkplaceAIProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['adminPatchWorkplaceAIProject']['parameters']['path']
  body: Exact<
    T,
    operations['adminPatchWorkplaceAIProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminPatchWorkplaceAIProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['WorkplaceAIProject']>(
    applyParameters('/api/v1/admin/serverless/projects/workplaceai/{id}', args),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/admin/serverless/projects/workplaceai/{id}
// ts-unused-exports:disable-next-line
export const deleteWorkplaceAIProject = async (args: {
  pathParameters: operations['adminDeleteWorkplaceAIProject']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/admin/serverless/projects/workplaceai/{id}', args), {
    method: 'DELETE',
  })

// GET /api/v1/admin/serverless/projects/workplaceai/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxyWorkplaceAIProjectGetRequest = async <
  T = operations['adminProxyWorkplaceAIProjectGetRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxyWorkplaceAIProjectGetRequest']['requestBody'],
        undefined
      >['content']['*:*'],
>(args: {
  pathParameters: operations['adminProxyWorkplaceAIProjectGetRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxyWorkplaceAIProjectGetRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxyWorkplaceAIProjectGetRequest']['requestBody'],
          undefined
        >['content']['*:*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/workplaceai/{id}/_proxy/{path}', args),
    {
      method: 'GET',
      body: JSON.stringify(args.body),
    },
  )

// PUT /api/v1/admin/serverless/projects/workplaceai/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxyWorkplaceAIProjectPutRequest = async <
  T = operations['adminProxyWorkplaceAIProjectPutRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxyWorkplaceAIProjectPutRequest']['requestBody'],
        undefined
      >['content']['*/*'],
>(args: {
  pathParameters: operations['adminProxyWorkplaceAIProjectPutRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxyWorkplaceAIProjectPutRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxyWorkplaceAIProjectPutRequest']['requestBody'],
          undefined
        >['content']['*/*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/workplaceai/{id}/_proxy/{path}', args),
    {
      method: 'PUT',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/admin/serverless/projects/workplaceai/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxyWorkplaceAIProjectPostRequest = async <
  T = operations['adminProxyWorkplaceAIProjectPostRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxyWorkplaceAIProjectPostRequest']['requestBody'],
        undefined
      >['content']['*/*'],
>(args: {
  pathParameters: operations['adminProxyWorkplaceAIProjectPostRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxyWorkplaceAIProjectPostRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxyWorkplaceAIProjectPostRequest']['requestBody'],
          undefined
        >['content']['*/*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/workplaceai/{id}/_proxy/{path}', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/admin/serverless/projects/workplaceai/{id}/_proxy/{path}
// ts-unused-exports:disable-next-line
export const proxyWorkplaceAIProjectDeleteRequest = async <
  T = operations['adminProxyWorkplaceAIProjectDeleteRequest']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['adminProxyWorkplaceAIProjectDeleteRequest']['requestBody'],
        undefined
      >['content']['*/*'],
>(args: {
  pathParameters: operations['adminProxyWorkplaceAIProjectDeleteRequest']['parameters']['path']
  body: Exact<
    T,
    operations['adminProxyWorkplaceAIProjectDeleteRequest']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['adminProxyWorkplaceAIProjectDeleteRequest']['requestBody'],
          undefined
        >['content']['*/*']
  >
}) =>
  fetchAsJson<components['schemas']['AnyValue']>(
    applyParameters('/api/v1/admin/serverless/projects/workplaceai/{id}/_proxy/{path}', args),
    {
      method: 'DELETE',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/admin/serverless/projects/workplaceai/{id}/_reprocess
// ts-unused-exports:disable-next-line
export const reprocessWorkplaceAIProject = async (args: {
  pathParameters: operations['adminReprocessWorkplaceAIProject']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/admin/serverless/projects/workplaceai/{id}/_reprocess', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/admin/serverless/projects/workplaceai/{id}/_restore
// ts-unused-exports:disable-next-line
export const restoreWorkplaceAIProject = async (args: {
  pathParameters: operations['adminRestoreWorkplaceAIProject']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/admin/serverless/projects/workplaceai/{id}/_restore', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/admin/serverless/projects/workplaceai/{id}/_rotate-fleet-token
// ts-unused-exports:disable-next-line
export const rotateWorkplaceAIProjectFleetToken = async (args: {
  pathParameters: operations['adminRotateWorkplaceAIProjectFleetToken']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/admin/serverless/projects/workplaceai/{id}/_rotate-fleet-token', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/admin/serverless/projects/workplaceai/{id}/_rotate-kibana-token
// ts-unused-exports:disable-next-line
export const rotateWorkplaceAIProjectKibanaToken = async (args: {
  pathParameters: operations['adminRotateWorkplaceAIProjectKibanaToken']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters(
      '/api/v1/admin/serverless/projects/workplaceai/{id}/_rotate-kibana-token',
      args,
    ),
    {
      method: 'POST',
    },
  )

// GET /api/v1/admin/serverless/projects/workplaceai/{id}/link-candidates
// ts-unused-exports:disable-next-line
export const getWorkplaceAIProjectLinkCandidates = async (args: {
  pathParameters: operations['adminGetWorkplaceAIProjectLinkCandidates']['parameters']['path']
  queryParameters?: operations['adminGetWorkplaceAIProjectLinkCandidates']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['LinkedCandidatesList']>(
    applyParameters('/api/v1/admin/serverless/projects/workplaceai/{id}/link-candidates', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/workplaceai/{id}/roles
// ts-unused-exports:disable-next-line
export const getWorkplaceAIProjectRoles = async (args: {
  pathParameters: operations['adminGetWorkplaceAIProjectRoles']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectRolesByProjectID']>(
    applyParameters('/api/v1/admin/serverless/projects/workplaceai/{id}/roles', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/admin/serverless/projects/workplaceai/{id}/status
// ts-unused-exports:disable-next-line
export const getWorkplaceAIProjectStatus = async (args: {
  pathParameters: operations['adminGetWorkplaceAIProjectStatus']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectStatus']>(
    applyParameters('/api/v1/admin/serverless/projects/workplaceai/{id}/status', args),
    {
      method: 'GET',
    },
  )
